export const BUILD_INFO = {
    version: '1.0.1',
    timestamp: '2026-02-03T22:12:00Z',
    recharts: '2.10.3',
    environment: import.meta.env.MODE,
};

// Log build info on app start
console.log('🚀 App Build Info:', BUILD_INFO);
